class LoginUrlPath {
    public static BASE = "/login";
}

export default LoginUrlPath;